import { black, blue, darkGrey, grey, red, textMuted, white } from '@/theme/colors'
import styled from 'styled-components'

export const Toolbar = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
	margin-bottom: 1rem;
	flex-wrap: wrap;
`

export const SearchInput = styled.input`
	flex: 1;
	min-width: 220px;
	max-width: 360px;
	padding: 0.55rem 0.75rem;
	border: 1px solid ${darkGrey};
	border-radius: 8px;
	font-size: 0.95rem;
	background-color: ${white};
	color: ${black};

	&:focus {
		outline: none;
		border-color: ${blue};
	}
`

export const ResultCount = styled.span`
	font-size: 0.9rem;
	color: ${textMuted};
	white-space: nowrap;
`

export const TableWrapper = styled.div`
	background-color: ${white};
	border-radius: 12px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
	overflow-x: auto;
`

export const Table = styled.table`
	width: 100%;
	border-collapse: collapse;
	font-size: 0.92rem;
`

export const Th = styled.th`
	text-align: left;
	padding: 0.85rem 1rem;
	font-weight: 600;
	color: ${textMuted};
	border-bottom: 1px solid ${grey};
	white-space: nowrap;
`

export const Td = styled.td`
	padding: 0.85rem 1rem;
	color: ${black};
	border-bottom: 1px solid ${grey};
	vertical-align: top;
`

export const Tr = styled.tr<{ $deleted?: boolean }>`
	cursor: pointer;
	opacity: ${({ $deleted }) => ($deleted ? 0.6 : 1)};
	transition: background-color 0.12s ease;

	&:hover {
		background-color: ${blue}0d;
	}

	&:last-child td {
		border-bottom: none;
	}
`

export const OwnerName = styled.div`
	font-weight: 500;
`

export const OwnerEmail = styled.div`
	font-size: 0.82rem;
	color: ${textMuted};
`

export const Muted = styled.span`
	color: ${textMuted};
`

export const DeletedBadge = styled.span`
	display: inline-block;
	margin-left: 0.5rem;
	padding: 0.1rem 0.45rem;
	border-radius: 999px;
	font-size: 0.72rem;
	font-weight: 700;
	color: ${white};
	background-color: ${red};
	vertical-align: middle;
`

export const InternalBadge = styled.span`
	display: inline-block;
	margin-left: 0.5rem;
	padding: 0.1rem 0.45rem;
	border-radius: 999px;
	font-size: 0.72rem;
	font-weight: 700;
	color: ${white};
	background-color: ${blue};
	vertical-align: middle;
`

export const Pagination = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 1rem;
	margin-top: 1rem;
`

export const PageButton = styled.button`
	padding: 0.5rem 1rem;
	border: 1px solid ${darkGrey};
	border-radius: 8px;
	background-color: ${white};
	color: ${blue};
	font-weight: 600;
	cursor: pointer;

	&:disabled {
		opacity: 0.5;
		cursor: default;
	}
`

export const PageStatus = styled.span`
	font-size: 0.9rem;
	color: ${textMuted};
`

export const EmptyState = styled.div`
	padding: 2.5rem 1rem;
	text-align: center;
	color: ${textMuted};
`

export const ErrorState = styled.div`
	color: ${textMuted};
	font-size: 1rem;
`
